export default __webpack_public_path__ + "monkey.a3d5fcdc50b18dc55695f7dd4101a8c9.svg";